module.exports = __webpack_public_path__ + "img/clientes-logo-2.9ee3c322.png";